import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmallCard = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 15,
	viewBox: "0 0 20 15",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.97631 1.09835C0.351189 1.80161 0 2.75544 0 3.75V11.25C0 12.2446 0.351189 13.1984 0.97631 13.9017C1.60143 14.6049 2.44928 15 3.33333 15H16.6667C17.5507 15 18.3986 14.6049 19.0237 13.9017C19.6488 13.1984 20 12.2446 20 11.25V3.75C20 2.75544 19.6488 1.80161 19.0237 1.09835C18.3986 0.395089 17.5507 0 16.6667 0H3.33333C2.44928 0 1.60143 0.395089 0.97631 1.09835ZM12 11.0769C12 10.4822 12.4822 10 13.0769 10H16.3077C16.9025 10 17.3846 10.4822 17.3846 11.0769C17.3846 11.6717 16.9025 12.1538 16.3077 12.1538H13.0769C12.4822 12.1538 12 11.6717 12 11.0769ZM4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z",
		fill: "#616161"
	})
});
const ForwardRef = forwardRef(SvgSmallCard);
export default ForwardRef;
